import {Injectable} from '@angular/core';
import {ApiService} from "../../api/api.service";
import {Observable} from "rxjs";
import {
  IAuthority,
  IAuthorityAssign
} from "../../../../pages/management/authorization-management/models/authority.interface";
import {IPagination} from "../../api/interface/pagination.interface";

@Injectable({
  providedIn: 'root'
})
export class AuthorizationService {

  constructor(private readonly apiService: ApiService) {
  }

  getFilter(event: any, filter: any): Observable<IPagination> {
    return this.apiService.getFilter<IPagination>(`authority/authority-filter-list`, {event: event, filter: filter})
  }

  getList() {
    return this.apiService.get<any>('authority')
  }

  getById(id: string) {
    return this.apiService.get<any>(`authority/${id}`)
  }

  create(authority: IAuthority): Observable<IAuthority> {
    return this.apiService.post<IAuthority>('authority/create', authority)
  }

  update(authority: IAuthority): Observable<IAuthority> {
    return this.apiService.patch<IAuthority>('authority/update', authority);
  }

  delete(authorityId: string,): Observable<IAuthority> {
    return this.apiService.delete<IAuthority>(`authority/delete/${authorityId}`);
  }

  assignAuthorityGroup(assignData: IAuthorityAssign[]) {
    return this.apiService.post<any>('authority/add-authority-group', assignData)
  }

  assignAction(assignData: any[]) {
    return this.apiService.post<any>('authority/add-action', assignData)
  }

  unassignAction(assignData: any[]) {
    return this.apiService.post<any>('authority/remove-actions', assignData)
  }

  getActionsWithUserDetails(userId: number, authorityId: number) {
    return this.apiService.get<any>(`authority/actions/${userId}/${authorityId}`)
  }

  getActionsWithRoleUserDetails(roleId: number, userId: number, authorityId: number) {
    return this.apiService.get<any>(`authority/actions/with-role/${roleId}/${userId}/${authorityId}`)
  }

}
